import { Constants } from 'app/shared/shared-constants';
import { isDate } from 'lodash';

export class SecureStringReplacer {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static replacer(key: string, value: any): any | undefined {
        if (key && SecureStringReplacer._isEmpty(value)) {
            // for v2 dataset, empty schema should also be kept.
            if (key === 'schema') {
                return value;
            }
            return undefined;
        }

        if (SecureStringReplacer.isSecureStringObject(value)) {
            return {
                type: 'SecureString',
                value: Constants.maskedCredential
            };
        }

        return value;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static keepEmptyObjectReplacer(key: string, value: any): any | undefined {
        if (SecureStringReplacer.isSecureStringObject(value)) {
            return {
                type: 'SecureString',
                value: Constants.maskedCredential
            };
        }

        return value;
    }

    public static isSecureStringObject<T>(object: T): boolean {
        let propertyCount = 0;

        for (const _property in object) {
            ++propertyCount;
        }

        if (propertyCount === 2 && object.hasOwnProperty('type')
            && object.hasOwnProperty('value')
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            && (object as any)['type'] === 'SecureString') {
            return true;
        }

        return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static _isEmpty(object: any): boolean {
        // This only works for swagger objects since they are all interfaces with no methods
        // We handle arrays like any other object except ignoring length
        // remove null check, because null is user specified value
        if (object === undefined || (object instanceof Function)) {
            return true;
        }
        if (object === '' || object !== Object(object)) {
            return false;
        }
        if (Array.isArray(object)) {
            if (object.length === 0) {
                return false;
            }
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for (let index = 0; index < object.length; index++) {
                const value = object[index];
                if (!SecureStringReplacer._isEmpty(value)) {
                    return false;
                }
            }
        } else {
            if (isDate(object)) {
                return false;
            }
            for (const propertyName of Object.getOwnPropertyNames(object)) {
                const value = object[propertyName];
                if (!SecureStringReplacer._isEmpty(value)) {
                    return false;
                }
            }
        }
        return true;
    }
}
